import { render, staticRenderFns } from "./vendor-category-select.vue?vue&type=template&id=77e937e0&"
import script from "./vendor-category-select.vue?vue&type=script&lang=js&"
export * from "./vendor-category-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports